import styled from "styled-components";
import { OrderBy } from "../../../../components/OrderBy";
import { Pagination } from "../../../../components/Pagination";
import { Search } from "../../../../hooks/useDecisions";
import { orderValues } from "../../helpers/submit";

interface ItemProps {
  flex?: number;
}

interface PageProps {
  selected?: boolean;
}
interface paramsProps {
  results?: any[];
  submit(search: Search|null, page: number, order: string): void;
  onClick(selected: { title: string, content: string }[]): void;
  pagination?: {
			page: number,
			pageSize: number,
			pageCount: number,
			total: number
  }|null;
}

type pageBtn = {
  page: number,
  selected: boolean
}
export function Results({ results, submit, pagination = null, onClick }: paramsProps) {
  if(!results) results = [];
  if(!pagination) pagination = {page: 0, pageCount: 0, pageSize: 10, total: 0};
  
  function mapRowModalData(item: any) {
    return [{
      title: "Data",
      content: item.date
    }, {
      title: "Título",
      content: item.title
    }, {
      title: "Relatoria",
      content: item?.relatoria?.length > 1? item.relatoria : item.author
    }, {
      title: "url",
      content: item.pdf_url
    }]
  }

  function iteratePages() {
    let pages: pageBtn[] = [];
    if(!pagination?.pageCount) return pages;

    const initialCount = pagination?.pageCount?  pagination?.pageCount : 0
    for (let i = 1; i <= initialCount; i++) {
      pages.push({
        page: i,
        selected: pagination?.page === i
      })
    }

    return pages;
  }
  
  async function onSubmit(page: number, e: any = null, order: string = '') {
    e && e.preventDefault();
    await submit(null, page, order);
  }

  async function handleOrder(order: string) {
    await submit(null, 0, order);
  }
  return (
    <Content>
      <OrderWrapper>
        <OrderBy options={orderValues} onClick={handleOrder} />
      </OrderWrapper>
      <Table>
        {results.length > 0 ? (
          <>
            <Head>
              <HeadItem flex={3}>Data</HeadItem>
              <HeadItem flex={9}>Título</HeadItem>
              <HeadItem flex={6}>Relatoria</HeadItem>
            </Head>
            <Body>
              {results.map((item: any, index: any) => (
                <BodyRow key={index} onClick={() => onClick(mapRowModalData(item))}>
                  <BodyItem flex={3}>{ item.date }</BodyItem>
                  <BodyItemForceWidth flex={9} title={item.title}><span>{ item.title }</span></BodyItemForceWidth>
                  <BodyItem flex={6}>{ item?.relatoria?.length > 1? item.relatoria : item.author }</BodyItem>
                </BodyRow>
              ))}
            </Body>
          </>
        ) : (
          <NoResults>
            Sem resultados recentes
          </NoResults>
        )}
      </Table>
      <Pagination
        max-width={'500px'}
        left={'53%'}
        transform={'translate(-50%, 40%)'}
        pages={iteratePages()}
        onSubmit={onSubmit}
      />
    </Content>
  );
}

const Content = styled.div`
  width: calc(54% - 12px);
  padding: 32px 0 0;
  position: relative;
  border: ${({ theme }) => `1px solid ${theme.colors.blue.dark}`};
  border-radius: 16px;
  padding: 32px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: calc(100% - 54px);
    margin: auto;
    padding: 32px 0;
    border: none;
    border-radius: 0;
    border-top: ${({ theme }) => `2px solid ${theme.colors.blue.dark}`};
  }
`;

const OrderWrapper = styled.div`
  margin-bottom: 16px;
  position: absolute;
  top: 0;
  left: 32px;
  transform: translateY(-50%);
  background-color: #fff;
  padding: 0 16px;
  max-width: 292px;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    position: static;
    padding: 0;
    font-size: 20px;
    // transform: none;
  }
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

const Head = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

const HeadItem = styled.span<ItemProps>`
  display: block;
  flex: ${({ flex }) => flex };
  font-size: 18px;
  color: ${({ theme }) => theme.colors.black.medium };
  font-style: italic;
`;

const Body = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  list-style-type: none;
`;

const BodyRow = styled.li`
  display: flex;
  border-bottom: ${({ theme }) => `1px dashed ${theme.colors.gray.darker}`};
  padding: 12px 0;
  cursor: pointer;

  &:last-child {
    border: none;
    padding-bottom: 0;
  }
`;

const BodyItem = styled.span<ItemProps>`
  display: block;
  flex: ${({ flex }) => flex };
  font-size: 15px;
  font-style: italic;
  color: ${({ theme }) => theme.colors.gray.darker };

  > span {
    display: inline-block;
    color: ${({ theme }) => theme.colors.black.medium };
    padding-right: 36px;
  }
`;

const BodyItemForceWidth = styled.span<ItemProps>`
  max-width: 300px;

  display: block;
  flex: ${({ flex }) => flex };
  font-size: 15px;
  font-style: italic;
  color: ${({ theme }) => theme.colors.gray.darker };

  > span {
    // display: inline-block;
    
    
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2; 
    -webkit-box-orient: vertical;

    color: ${({ theme }) => theme.colors.black.medium };
    padding-right: 36px;
  }
`;

const NoResults = styled.span`
  display: block;
  text-align: center;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.gray.darker };
`;


export const PageButton = styled.button<PageProps>`
  min-width: 25px;
  padding: 0px 6px;
  max-width: max-content;
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.blue.dark };
  color: ${({ theme, selected }) => selected? theme.colors.pink.light : theme.colors.gray.light };
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  height: 36px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: none;
  bottom: 0;
  cursor: pointer;
  margin-right: 10px
`;
